import NZContact from "../../../components/NZComponent/home/NZContact/NZContact";
import PETROLSIDE from "../../../assets/png/PETROLSIDE.png";
import { useNavigate } from "react-router";
import PETROLModels from "../../../components/NZComponent/NzPetrol/PETROLModels";
import HighLevelSpecs from "../../../components/NZComponent/NzPetrol/HighLevelSpecs";
import NZNZPetrolGregFarrier from "../../../components/NZComponent/NzPetrol/NZNZPetrolGregFarrier";
import NZElectricaTV from "../../../components/NZComponent/NzPetrol/NZElectricaTV";
import HomeIcon from "../../../assets/svg/HomeIcon.svg";
import RightSideArrow from "../../../assets/svg/RightSideArrow.svg";
import NZGregFarrier from "../../../components/NZComponent/home/NZGregFarrier/NZGregFarrier";
import NZGregAssociates from "../../../components/NZComponent/home/NZGregAssociates/NZGregAssociates";
import Gallary_One from "../../../assets/images/Gallary/Gallary_One.png";
import Gallary_Two from "../../../assets/images/Gallary/Gallary_Two.png";
import Gallary_Three from "../../../assets/images/Gallary/Gallary_Three.png";
import Gallary_Four from "../../../assets/images/Gallary/Gallary_Four.png";
import Gallary_Fifth from "../../../assets/images/Gallary/Gallary_Fifth.png";
import Gallary_Six from "../../../assets/images/Gallary/Gallary_Six.png";
import Gallary_Seventh from "../../../assets/images/Gallary/Gallary_Seventh.png";
import Gallary_Eighth from "../../../assets/images/Gallary/Gallary_Eighth.png";
import Gallary_Nine from "../../../assets/images/Gallary/Gallary_Nine.png";
import Gallary_Ten from "../../../assets/images/Gallary/Gallary_Ten.png";
import Gallary_Eleven from "../../../assets/images/Gallary/Gallary_Eleven.png";
import Gallary_twelve from "../../../assets/images/Gallary/Gallary_twelve.png";
import CardUpImg from "../../../assets/svg/nz-bg-card-up-white.svg";
import SEOMetadata from "../../../components/SEOMetadata";
import { seoConfig } from "../../../config/seoConfig";
import Gallary_1 from "../../../assets/images/Gallary/1000EFIVehicleinOtago(NZ).jpg";
import Gallary_2 from "../../../assets/images/Gallary/1500E-2inGermany1.jpg";
import Gallary_3 from "../../../assets/images/Gallary/1500EinforestGermany1.jpg";
import Gallary_4 from "../../../assets/images/Gallary/1500EinforestGermany2.jpg";
import Gallary_5 from "../../../assets/images/Gallary/1500EinforestGermany4.jpg";
import Gallary_6 from "../../../assets/images/Gallary/CalfFeeding.jpg";
import Gallary_7 from "../../../assets/images/Gallary/eTuatara-Loaded.jpg";
import Gallary_8 from "../../../assets/images/Gallary/Kiwifruitfarm.jpg";
import Gallary_9 from "../../../assets/images/Gallary/Polishmining1.jpg";
import Gallary_10 from "../../../assets/images/Gallary/Polishmining2.jpg";
import Gallary_11 from "../../../assets/images/Gallary/PowerlineMaintenance.jpg";
import Gallary_12 from "../../../assets/images/Gallary/Tuatara1000Trailer(5).jpg";
import Gallary_13 from "../../../assets/images/Gallary/Tuataraaction1.jpg";
import Gallary_14 from "../../../assets/images/Gallary/Tuatarawithspraytank.jpg";
import Gallary_15 from "../../../assets/images/Gallary/PioneerEnergy1.jpg";
import { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const NZGallery = () => {
  const seoData = seoConfig.nz.gallery;
  let navigate = useNavigate();
  const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });
  const [showTooltip, setShowTooltip] = useState(false);
  const [openImage, setOpenImage] = useState(null);
  const [sliderOpen, setSliderOpen] = useState(false);
  const [sliderIndex, setSliderIndex] = useState(0);

  return (
    <>
      <SEOMetadata
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
      />
      <div>
        <div className="px-[12px] py-[6px] bg-[#F0F0F0] flex items-center">
          <img
            src={HomeIcon}
            alt="HomeIcon"
            className="cursor-pointer"
            onClick={() => navigate("/")}
          />
          <div className="flex items-center mx-[5px]">
            <img src={RightSideArrow} alt="RightSideArrow" />
            <img src={RightSideArrow} alt="RightSideArrow" />
          </div>
          <div className="text-[14px] leading-[24px] text-[#383838] montserrat-semi-bold">{`Gallery`}</div>
        </div>
        <div className="w-full bg-fixed bg-cover bg-center">
          {" "}
          <div className="w-full flex items-center justify-center">
            <div
              className="text-white kuunari-bold 
                      text-[40px] 
                      md:text-[80px] 
                      lg:text-[120px]  py-[68px] max-w-[1127px] text-center"
              style={{
                textShadow: "2px 4px 6px #000000",
              }}
            >
              Gallery
            </div>
          </div>
          <img src={CardUpImg} className="w-full" />
        </div>
        <div className="bg-white pt-[60px] pb-[45px]">
          <div className="custom-container px-[30px] text-start mx-auto ">
            <div className="max-w-[1200px]  mx-auto">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-5 max-w-[1400px] mx-auto">
                <img
                  src={Gallary_1}
                  className="w-full aspect-[4/3] object-cover cursor-pointer border border-black"
                  onMouseMove={(e) => {
                    setTooltipPos({ x: e.clientX, y: e.clientY });
                    setShowTooltip(true);
                  }}
                  onMouseLeave={() => setShowTooltip(false)}
                  onClick={() => {
                    setSliderIndex(0);
                    setSliderOpen(true);
                  }}
                />

                <img
                  src={Gallary_2}
                  alt="2"
                  className="w-full aspect-[4/3] object-cover cursor-pointer border border-black"
                  onMouseMove={(e) => {
                    setTooltipPos({ x: e.clientX, y: e.clientY });
                    setShowTooltip(true);
                  }}
                  onMouseLeave={() => setShowTooltip(false)}
                  onClick={() => {
                    setSliderIndex(1);
                    setSliderOpen(true);
                  }}
                />
                <img
                  src={Gallary_3}
                  alt="3"
                  className="w-full aspect-[4/3] object-contain cursor-pointer border border-black"
                  onMouseMove={(e) => {
                    setTooltipPos({ x: e.clientX, y: e.clientY });
                    setShowTooltip(true);
                  }}
                  onMouseLeave={() => setShowTooltip(false)}
                  onClick={() => {
                    setSliderIndex(2);
                    setSliderOpen(true);
                  }}
                />
                <img
                  src={Gallary_4}
                  alt="4"
                  className="w-full aspect-[4/3] object-cover cursor-pointer border border-black"
                  onMouseMove={(e) => {
                    setTooltipPos({ x: e.clientX, y: e.clientY });
                    setShowTooltip(true);
                  }}
                  onMouseLeave={() => setShowTooltip(false)}
                  onClick={() => {
                    setSliderIndex(3);
                    setSliderOpen(true);
                  }}
                />
                <img
                  src={Gallary_5}
                  alt="5"
                  className="w-full aspect-[4/3] object-cover cursor-pointer border border-black"
                  onMouseMove={(e) => {
                    setTooltipPos({ x: e.clientX, y: e.clientY });
                    setShowTooltip(true);
                  }}
                  onMouseLeave={() => setShowTooltip(false)}
                  onClick={() => {
                    setSliderIndex(4);
                    setSliderOpen(true);
                  }}
                />
                <img
                  src={Gallary_6}
                  alt="6"
                  className="w-full aspect-[4/3] object-cover cursor-pointer border border-black"
                  onMouseMove={(e) => {
                    setTooltipPos({ x: e.clientX, y: e.clientY });
                    setShowTooltip(true);
                  }}
                  onMouseLeave={() => setShowTooltip(false)}
                  onClick={() => {
                    setSliderIndex(5);
                    setSliderOpen(true);
                  }}
                />
                <img
                  src={Gallary_7}
                  alt="7"
                  className="w-full aspect-[4/3] object-cover cursor-pointer border border-black"
                  onMouseMove={(e) => {
                    setTooltipPos({ x: e.clientX, y: e.clientY });
                    setShowTooltip(true);
                  }}
                  onMouseLeave={() => setShowTooltip(false)}
                  onClick={() => {
                    setSliderIndex(6);
                    setSliderOpen(true);
                  }}
                />
                <img
                  src={Gallary_8}
                  alt="8"
                  className="w-full aspect-[4/3] object-cover cursor-pointer border border-black"
                  onMouseMove={(e) => {
                    setTooltipPos({ x: e.clientX, y: e.clientY });
                    setShowTooltip(true);
                  }}
                  onMouseLeave={() => setShowTooltip(false)}
                  onClick={() => {
                    setSliderIndex(7);
                    setSliderOpen(true);
                  }}
                />
                <img
                  src={Gallary_9}
                  alt="9"
                  className="w-full aspect-[4/3] object-cover cursor-pointer border border-black"
                  onMouseMove={(e) => {
                    setTooltipPos({ x: e.clientX, y: e.clientY });
                    setShowTooltip(true);
                  }}
                  onMouseLeave={() => setShowTooltip(false)}
                  onClick={() => {
                    setSliderIndex(8);
                    setSliderOpen(true);
                  }}
                />
                <img
                  src={Gallary_10}
                  alt="10"
                  className="w-full aspect-[4/3] object-cover cursor-pointer object-[5%] border border-black"
                  onMouseMove={(e) => {
                    setTooltipPos({ x: e.clientX, y: e.clientY });
                    setShowTooltip(true);
                  }}
                  onMouseLeave={() => setShowTooltip(false)}
                  onClick={() => {
                    setSliderIndex(9);
                    setSliderOpen(true);
                  }}
                />
                <img
                  src={Gallary_11}
                  alt="11"
                  className="w-full aspect-[4/3] object-cover cursor-pointer border border-black"
                  onMouseMove={(e) => {
                    setTooltipPos({ x: e.clientX, y: e.clientY });
                    setShowTooltip(true);
                  }}
                  onMouseLeave={() => setShowTooltip(false)}
                  onClick={() => {
                    setSliderIndex(10);
                    setSliderOpen(true);
                  }}
                />
                <img
                  src={Gallary_12}
                  alt="12"
                  className="w-full aspect-[4/3] object-cover cursor-pointer border border-black"
                  onMouseMove={(e) => {
                    setTooltipPos({ x: e.clientX, y: e.clientY });
                    setShowTooltip(true);
                  }}
                  onMouseLeave={() => setShowTooltip(false)}
                  onClick={() => {
                    setSliderIndex(11);
                    setSliderOpen(true);
                  }}
                />
                <img
                  src={Gallary_13}
                  alt="13"
                  className="w-full aspect-[4/3] object-cover cursor-pointer object-[88%] border border-black"
                  onMouseMove={(e) => {
                    setTooltipPos({ x: e.clientX, y: e.clientY });
                    setShowTooltip(true);
                  }}
                  onMouseLeave={() => setShowTooltip(false)}
                  onClick={() => {
                    setSliderIndex(12);
                    setSliderOpen(true);
                  }}
                />
                <img
                  src={Gallary_14}
                  alt="14"
                  className="w-full aspect-[4/3] object-cover cursor-pointer border border-black"
                  onMouseMove={(e) => {
                    setTooltipPos({ x: e.clientX, y: e.clientY });
                    setShowTooltip(true);
                  }}
                  onMouseLeave={() => setShowTooltip(false)}
                  onClick={() => {
                    setSliderIndex(13);
                    setSliderOpen(true);
                  }}
                />
                <img
                  src={Gallary_15}
                  alt="15"
                  className="w-full aspect-[4/3] object-cover cursor-pointer border border-black"
                  onMouseMove={(e) => {
                    setTooltipPos({ x: e.clientX, y: e.clientY });
                    setShowTooltip(true);
                  }}
                  onMouseLeave={() => setShowTooltip(false)}
                  onClick={() => {
                    setSliderIndex(14);
                    setSliderOpen(true);
                  }}
                />
              </div>
              {/* FULLSCREEN SLIDER MODAL */}
              {/* ---------------- FULL SCREEN MANUAL SLIDER ---------------- */}
              {sliderOpen && (
                <div
                  className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[99999]"
                  onClick={() => setSliderOpen(false)}
                >
                  <div
                    className="relative"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {/* CLOSE BUTTON */}
                    <button
                      onClick={() => setSliderOpen(false)}
                      className="absolute top-[-50px] right-0 text-white text-5xl cursor-pointer"
                    >
                      ×
                    </button>

                    {/* LEFT ARROW */}
                    <button
                      onClick={() =>
                        setSliderIndex(sliderIndex === 0 ? 14 : sliderIndex - 1)
                      }
                      className="absolute left-[-60px] top-1/2 -translate-y-1/2 text-white text-6xl cursor-pointer"
                    >
                      ‹
                    </button>

                    {/* MAIN IMAGE */}
                    <img
                      src={
                        [
                          Gallary_1,
                          Gallary_2,
                          Gallary_3,
                          Gallary_4,
                          Gallary_5,
                          Gallary_6,
                          Gallary_7,
                          Gallary_8,
                          Gallary_9,
                          Gallary_10,
                          Gallary_11,
                          Gallary_12,
                          Gallary_13,
                          Gallary_14,
                          Gallary_15,
                        ][sliderIndex]
                      }
                      className="max-h-[80vh] max-w-[90vw] object-contain bg-white rounded-lg shadow-xl"
                    />

                    {/* RIGHT ARROW */}
                    <button
                      onClick={() =>
                        setSliderIndex(sliderIndex === 14 ? 0 : sliderIndex + 1)
                      }
                      className="absolute right-[-60px] top-1/2 -translate-y-1/2 text-white text-6xl cursor-pointer"
                    >
                      ›
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {showTooltip && (
          <div
            className="fixed z-[99999] bg-black text-white text-[13px] px-3 py-1 rounded-md shadow-lg pointer-events-none"
            style={{ top: tooltipPos.y + 15, left: tooltipPos.x + 15 }}
          >
            Click here to expand
          </div>
        )}
        {openImage && (
          <div
            className="fixed inset-0 bg-black/70 flex items-center justify-center z-[99999]"
            onClick={() => setOpenImage(null)}
          >
            <img
              src={openImage}
              className="max-w-[95%] max-h-[95%] rounded-lg object-contain shadow-xl"
            />
          </div>
        )}

        <NZGregFarrier
          bg={"#fff"}
          slogan="“THIS IS HANDS DOWN THE MOST VERSATILE ATV I HAVE PURCHASED FOR THE FARM.”"
        />
        <div id="contact-form">
          <NZContact />
        </div>
        {/* <NZGregAssociates /> */}
      </div>
    </>
  );
};
export default NZGallery;
